import { AnalyseStatut } from './enum/analyse-statut';
import { Taxon } from './taxon';
import { User } from '../planning/user';
import { Omnidia } from './omnidia';
import { EInterventionStatus } from '../planning/enum/intervention-status';
import { EInterventionType } from '../planning/enum/intervention-type';
import { ELIMSData } from '../Shared/elims-data';
import { AnalyseCyano } from '../cyano/analyse-cyano';

export class Analyse {
    Code: string;
    InterventionCode: string;
    SampleCode: string;
    Status: AnalyseStatut;
    Type: EInterventionType;
    Date: Date;
    DateRenduClient: Date;
    Duration: number;
    DateTri: Date;
    DurationTri: number;
    Omnidia: Omnidia = new Omnidia();
    TaxonList: Taxon[] = [];
    MergedTaxonList: Taxon[] = [];
    AnalyserList: User[] = [];
    SorterList: User[] = [];
    NombrePhase: number;
    ValidatedByFullname: string;
    Interpretation: string;
    ELIMSData: ELIMSData = new ELIMSData();
    PartnerCode: string;
    AnalyseCyano: AnalyseCyano = new AnalyseCyano();

    static mapFromJson(json): any {
        const a = new Analyse();

        a.Code = json.code;
        a.InterventionCode = json.interventionCode;
        a.SampleCode = json.sampleCode;
        a.Type = json.type;
        a.Status = json.status;
        a.Date = json.date;
        a.Duration = json.duration;
        a.DateTri = json.dateTri;
        a.DurationTri = json.durationTri;
        a.NombrePhase = json.nombrePhase;
        a.ValidatedByFullname = json.validatedByFullname;
        a.Interpretation = json.interpretation;
        a.DateRenduClient = json.dateRenduClient;
        a.PartnerCode = json.partnerCode;

        if (json.Omnidia) {
            a.Omnidia = Omnidia.mapFromJSON(json.Omnidia);
        }

        if (json.analyseCyano) {
            a.AnalyseCyano = AnalyseCyano.mapFromJSON(json.analyseCyano);
        }

        if (json.elimsData) {
            a.ELIMSData = ELIMSData.mapFromJSON(json.elimsData);
        }

        if (json.analystes) {
            a.AnalyserList = json.analystes.map(jsonItem => User.mapFromJSON(jsonItem));
        }

        if (json.trieurs) {
            a.SorterList = json.trieurs.map(jsonItem => User.mapFromJSON(jsonItem));
        }

        if (json.taxons) {
            a.TaxonList = json.taxons.map(jsonItem => Taxon.mapFromJSON(jsonItem));
        }
        return a;
    }
}
